import { Paper, Typography, Chip, Link, Box } from "@mui/material";
import ArticleTitle from "./ArticleTitle";
import { RetractedWork } from "./CommonInterfaces";
import RetractionReasonList from "./RetractionReasonList";
import FingerprintIcon from '@mui/icons-material/Fingerprint';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import ImportContactsIcon from '@mui/icons-material/ImportContacts';

interface RetractionPanelProps {
  retraction: RetractedWork,
  index: number
  retractionIndex: number
}

function RetractionPanel({ retraction, index, retractionIndex }: RetractionPanelProps) {

  return <Paper sx={{ m: 2, p: 2 }} key={'retraction_' + index + '_' + retractionIndex}>
    <Typography gutterBottom variant="h5" component="div">
      <ArticleTitle title={retraction.title} />
      { retraction.source != "Scitility" &&
      <Chip label={retraction.retractionNature === "Retraction" && retraction.highRisk ? "High Risk Retraction" : retraction.retractionNature} color={retraction.retractionNature === 'Retraction' && retraction.highRisk ? "error" : "warning"} sx={{
        marginLeft: 2,
        color: 'white'
      }} />
    }
    </Typography>
    <Box key={'retraction_' + index + '_' + retractionIndex + '_box'}>
      <Typography variant="caption" sx={{
        mr: 1,
        mt: 1
      }}>Authors:</Typography>
      {retraction.authors.map((author, i) =>
        <Chip
          label={author}
          key={i}
          variant="outlined"
          component="h3"
          color="info"
          size="small"
          sx={{
            mr: 1,
            mt: 1,
            fontWeight: "regular",
            backgroundColor: '#FFFFFF'
          }}
        />
      )}
    </Box>
    <Chip component="h3" icon={<ImportContactsIcon />} label={"Journal: " + retraction.journal} variant="outlined" sx={{
      mr: 1,
      mt: 1,
      backgroundColor: '#FFFFFF',
      fontWeight: "regular"
    }} />
    <Chip component="h3" icon={<ImportContactsIcon />} label={"Publisher: " + retraction.publisher} variant="outlined" sx={{
      mr: 1,
      mt: 1,
      backgroundColor: '#FFFFFF',
      fontWeight: "regular"
    }} />
    <Chip component="h3" icon={<CalendarMonthIcon />} label={"Publication date:" + retraction.originalPaperDate} variant="outlined" sx={{
      mr: 1,
      mt: 1,
      fontWeight: "regular",
      backgroundColor: '#FFFFFF'
    }} />
    <Link href={retraction.originalPaperDoi} target="_blank">
      <Chip component="h3" icon={<FingerprintIcon />} label={"Original DOI:" + retraction.originalPaperDoi.replace('https://doi.org/', '')} variant="outlined" sx={{
        mr: 1,
        mt: 1,
        fontWeight: "regular",
        backgroundColor: '#FFFFFF'
      }} /></Link>
    {retraction.retractionDoi &&
      <Typography variant="body2" component="div">
        Retraction DOI:
        <Link href={retraction.retractionDoi} target="_blank">
          <Chip icon={<FingerprintIcon />} label={retraction.retractionDoi.replace('https://doi.org/', '')} component="h3" variant="outlined" sx={{
            mr: 1,
            mt: 1,
            fontWeight: "regular",
            backgroundColor: '#FFFFFF',

          }} /></Link>
      </Typography>}
    <Typography variant="body2" component="div">
      Retraction source:
      <Chip label={retraction.source} variant="outlined" sx={{
        mr: 1,
        mt: 1,
        backgroundColor: '#FFFFFF',
      }} />
    </Typography>
    {retraction.retractionDate && retraction.retractionDate !== 'null' && retraction.retractionDate !== '-999999999-01-01' &&
      <Typography variant="body2" component="div">
        Retraction date:
        <Chip icon={<CalendarMonthIcon />} label={retraction.retractionDate} variant="outlined" sx={{
          mr: 1,
          mt: 1,
          backgroundColor: '#FFFFFF',
        }} />
      </Typography>}
    
      { (retraction.source != "Scitility" && retraction.reasons) &&
      <Typography gutterBottom variant="body1" component="div">
        Reason(s): <RetractionReasonList reasons={retraction.reasons} />
      </Typography>}
    {retraction.notes &&
      <Typography gutterBottom variant="body1" component="div">
        Notes(s): {retraction.notes}
      </Typography>}
  </Paper>

}

export default RetractionPanel